import { ConfigProvider } from "antd"
import mnMN from 'antd/locale/mn_MN'

function StyleConfigProvider ({children}) {
  return(
    <ConfigProvider 
      locale={mnMN}
      drawer={{
        styles:{
          mask: {
            // backdropFilter: 'blur(8px)',
          },
          content: {
            borderRadius: '12px',
          },
        }
      }}
      theme={{
        token: {
          fontFamily: `'Roboto', sans-serif`,
          colorPrimary: '#3E66FB',
          // colorBgContainerDisabled: 'transparent',
          colorBgContainerDisabled: '#FBFBFB',
          // colorTextDisabled: '#171725'
        },
        components: {
          Menu: {
            collapsedWidth: 64
          },
          Button: {
            // colorPrimaryHover: '#1F337E',
            // colorPrimaryBg: '#1F337E',
            // primaryColor: '#1F337E',
            // primaryShadow: '0px 0px 16px 0px rgba(53, 84, 209, 0.65)'
          },
          Table: {
            // headerBg: '#EBEFFF',
            headerBg: 'transparent',
            headerColor: '#616569',
            headerBorderRadius: 8,
            fontWeightStrong: '500',
            borderColor: '#F0F1F3',
            colorText: '#171725',
            fontSize: 14,
            // colorBgContainer: '#FBFBFB',
            colorBgContainer: 'transparent',
            // selectionColumnWidth: 40
            selectionColumnWidth: 0
          },
          Modal: {
            headerBg: '',
            titleColor: '#08246d'
          },
          Form: {
            labelColor: '#91979D',
            labelFontSize: 'inherit',
            verticalLabelPadding: 0,
          },
          Popconfirm: {
            zIndexPopup: 2000
          },
          Tabs: {
            itemColor: '#91979D',
            colorText: '#171725'
          },
          Progress: {
            // defaultColor: '#08246d',
            colorText: '#91979D',
            defaultColor: '#3E66FB',
          },
          Steps: {
            marginSM: 8,
            colorPrimary: '#3E66FB',
          },
          Segmented: {
            itemColor: '#3E66FB',
            itemHoverColor: '#3E66FB',
            itemSelectedBg: '#FBFBFB',
            itemSelectedColor: '#3E66FB',
            boxShadowTertiary: '0px 0px 8px 0px rgba(97, 159, 243, 0.25);',
            controlPaddingHorizontal: 25,
            controlHeight: 35,
          }
        }
      }}
    >
      {children}
    </ConfigProvider>
  )
  
}

export default StyleConfigProvider